export default __webpack_public_path__ + "static/media/carousel4.80c406d5.jpg";